export function getAllProducts(state) {
  //var allProducts =  Object.values(state.products);
  //console.log("[>>] getAllProducts " + Object.values(state.products));
  return Object.values(state.products);
}